"use client"; 

import { useState } from 'react'
import axios from 'axios'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'


import { classNames } from '../../../../../lib/helpers' 
// import logger from '../../lib/logger' 



export default function FeedbackForm({ messages: m }) {
  // const logPx = 'Pages.UserFedback'

  const { register, handleSubmit, watch, formState, clearErrors, setError, reset } = useForm({ mode: 'onSubmit' });
  const { errors } = formState;
  const [isFormLoading, setIsFormLoading] = useState(false);  // To disable Button while loading


  const onSubmit = data => {
    // logger.info(`${logPx} Form Submitted with data: ${JSON.stringify(data)}`)
    setIsFormLoading(true);

    const submitData = data

    axios({
      method: 'POST',
      url: '/api/services/userfeedback',
      data: submitData,
    }).then(response => {
        // logger.info(`${logPx} Form Response data: ${JSON.stringify(response?.data)}`)
        setIsFormLoading(false);
        reset();
        toast.success("Thank you for your feedback!");
      }).catch((error) => {
        // logger.info(`${logPx} Form Response Error: ${error}`)
        setIsFormLoading(false);      
        toast.error("Something went wrong!");
      });
  } 


  return (
    <form 
      className="" 
      method="POST"
      onSubmit={handleSubmit(onSubmit)}
    >
        <div>
          <div className="mt-1">

          <textarea {...register("message", { required: m.message.required, maxLength: { value: 600, message: m.message.tooLong } })} 
          // pattern: { value: rgx.email, message: "It looks like that isn't a valid email address."} 
            placeholder={m.message.placeholder}
            className={classNames(errors.message ? 'border-red-300 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-crisp-500 focus:border-crisp-500', 'shadow-sm block w-full sm:text-base rounded-md')}
            rows={6}
          />

          {errors.message && (
            <p className="mt-2 text-base text-red-600">                      
              {/* {errors?.message?.message} */}
              {/* {JSON.stringify(errors.message)} */}                      
              {errors?.message?.message}
            </p>
          )}
          </div>
        </div>


        <div className='mt-6'>
          <button
            type="submit"
            disabled={isFormLoading}
            className={classNames(isFormLoading ? 'animate-pulse' : '', 'block w-full rounded-md shadow border border-transparent  bg-crisp-700 hover:bg-crisp-600 px-8 py-3 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-crisp-500')}
          >
            {m.button.name}
          </button>
        </div>

    </form>
  )
}